import { useCallback } from 'react';
import type { Product } from '../../../catalog/domain-api';
import type { AddProductToCartOptions } from '../../store/usePosStore';
import { usePosPriceListStore } from '../../store/usePosPriceListStore';
import { unitPriceWithOptions } from '../../../catalog/domain-api';

export function usePosPricedAddToCart(
  addProductToCart: (product: Product, quantityOrOpts?: number | AddProductToCartOptions) => void,
) {
  const resolveProductUnitPrice = usePosPriceListStore((s) => s.resolveProductUnitPrice);

  return useCallback(
    (product: Product, quantityOrOpts: number | AddProductToCartOptions = 1) => {
      const opts: AddProductToCartOptions =
        typeof quantityOrOpts === 'number' ? { quantity: quantityOrOpts } : quantityOrOpts ?? {};
      if (opts.unitPrice != null && Number.isFinite(opts.unitPrice)) {
        addProductToCart(product, opts);
        return;
      }
      const menuOptions = opts.menuOptions;
      const base = unitPriceWithOptions(product.price, menuOptions);
      const resolved = resolveProductUnitPrice({
        productId: product.id,
        variantId: opts.variantId,
        basePrice: base,
        quantity: opts.quantity ?? 1,
      });
      addProductToCart(product, { ...opts, unitPrice: resolved });
    },
    [addProductToCart, resolveProductUnitPrice],
  );
}
